<div class="container-fluid">
  <div class="row nyt-showcase__padding">
    <div class="col-md-2 pl-0 nyt-showcase__padding--mobile">
      <section class="nyt-showcase">
        <a href="https://developer.nytimes.com/" target="blank" class="nyt-showcase__link"></a>
        <h2 data-automation-id="nyt-showcase-title" class="nyt-showcase__title">The New York Times
          <sup class="nyt-showcase__reg">&reg;</sup>
        </h2>
        <p
          data-automation-id="nyt-showcase-bestseller-title"
          class="nyt-showcase__title nyt-showcase__title--best"
          translate>
          bestSellers
        </p>
        <h3
          class="nyt-showcase__title nyt-showcase__title--name mb-4 mb-sm-5"
          data-automation-id="showcase-nyTimes-title">
          {{name}}
        </h3>
        <app-see-all-button
          class="d-none d-md-block nyt-showcase__see-all"
          *ngIf="isNYTshowcaseSeeAllButtonVisible"
          seeAllType="see-all-resources"
          [url]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', identifier] : ['/search', 'card']"
          [queryParams]="{
            id: entity.id,
            entityType: entity.entityType,
            showcase: showcaseType,
            identifier: identifier || null,
            showcaseId: showcaseId || null
          }">
          {{ 'seeAll' | translate }} {{ 'NYTBestsellersTitleSeeAll' | translate }}
        </app-see-all-button>
      </section>
    </div>
    <div class="col-md-10 nyt-showcase__padding--mobile">
      <ul class="nyt-showcase__resources list-unstyled mb-0">
        <li
          class="nyt-showcase__resources-item mb-sm-13"
          *ngFor="let resource of resources | slice:0:visibleItemLength; let i = index">
          <app-single-showcase-resource
            *ngIf="i + 1 !== resourcePerPage || !isSeeAllButtonVisible"
            [resource]="resource"
            [index]="i"
            [entityId]="entity.id"
            [showcaseType]="showcaseType">
          </app-single-showcase-resource>
        </li>
      </ul>
      <app-see-all-button
        *ngIf="isNYTshowcaseSeeAllButtonVisibleMobile"
        class="d-block d-md-none nyt-showcase__see-all"
        seeAllType="see-all-resources"
        [url]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', identifier] : ['/search', 'card']"
        [queryParams]="{
          id: entity.id,
          entityType: entity.entityType,
          showcase: showcaseType,
          identifier: identifier || null,
          showcaseId: showcaseId || null
        }">
        {{ 'seeAll' | translate }} {{ 'NYTBestsellersTitleSeeAll' | translate }}
      </app-see-all-button>
    </div>
  </div>
</div>
